export const SET_SHARE_DETAIL = 'SET_SHARE_DETAIL';